/**
 * Proof tiles shared by Homepage v2, /syre and the printed banner (addendum
 * Oct 6, v3). Each tile is code-checked; see docs/build/copy-changes.md.
 * Never re-add founder portfolio numbers (houses, rooms, occupancy, locks).
 */
export const PROOF_TILES: ReadonlyArray<{ value: string; label: string }> = [
  { value: "60s", label: "message sync" },
  { value: "24/7", label: "AI-drafted replies · beta access, when enabled" },
  { value: "3", label: "daily buy box agents" },
];

export const PROOF_LINE = "Built by a top 1% PadSplit host to run his own co-living houses.";
